var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIbGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.896 4.335L4.13 0h4.84L4.896 4.335zm10.049 0L10.869 0h4.84l-.764 4.335zm-8.87.015h7.692L9.92.258 6.074 4.35zm13.766 0h-4l.708-4.02 3.292 4.02zM0 4.35h4L3.293.33 0 4.35zm15.84.877h4.001l-8.664 10.14 4.663-10.14zm-10.858 0L9.92 16l4.94-10.773H4.98zm3.682 10.14L0 5.227h4l4.664 10.14z",
    fill: "url(#paint0_linear_377_13628)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_377_13628",
    x1: 19.841,
    y1: 16,
    x2: 19.841,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE009D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7700C9"
  })))));
}
SvgIconIbGradient.displayName = 'IconIbGradient';
export default SvgIconIbGradient;